import React, { useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import StatsCounter from "./components/StatsCounter";
import Testimonials from "./components/Testimonials";
import ServiceCards3D from "./components/ServiceCards3D";
import Portfolio from "./components/Portfolio";
import SmartContact from "./components/SmartContact";
import Footer from "./components/Footer";
import Background3D from "./components/Background3D";
import Loader from "./components/Loader";
import ParticleSystem from "./components/ParticleSystem";
import DNAHelix from "./components/DNAHelix";
import ScrollToTop from "./components/ScrollToTop";
import FloatingActions from "./components/FloatingActions";
import CursorFollower from "./components/CursorFollower";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToHashHandler from "./components/ScrollToHashHandler";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import Disclaimer from "./components/Disclaimer";
import RefundReturn from "./components/RefundReturn";


function App() {
  const [dark, setDark] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  // Removed useLocation and scroll-to-hash effect

  React.useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  React.useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1800);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader onFinish={() => setLoading(false)} />;

  return (
    <Router>
      <ScrollToHashHandler />
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/refund-return" element={<RefundReturn />} />
        <Route path="/*" element={
          <>
            <Background3D dark={dark} />
            <ParticleSystem dark={dark} interactive={true} />
            <DNAHelix dark={dark} className="opacity-20" />
            <div className="z-30 relative min-h-screen bg-gradient-to-br from-white/70 to-indigo-100/60 dark:from-[#1b1c4e]/80 dark:to-[#23244d]/70 transition-colors duration-500">
              <Header dark={dark} setDark={setDark} menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
              <Hero dark={dark} />
              <About dark={dark} />
              <ServiceCards3D dark={dark} />
              <StatsCounter dark={dark} />
              <Testimonials dark={dark} />
              <Portfolio dark={dark} />
              <SmartContact dark={dark} />
              <Footer dark={dark} />
            </div>
            <ScrollToTop dark={dark} />
            <FloatingActions dark={dark} />
            <CursorFollower dark={dark} />
          </>
        } />
      </Routes>
    </Router>
  );
}

export default App;
